import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import cx from "classnames"

export interface GovtWizardPracticeStackProps {
  icon: IconDefinition
  header: string
  text: string
  selected: boolean
  onClick: () => void
}

const GovtWizardPracticeStack = ({
  icon,
  header,
  text,
  selected,
  onClick,
}: GovtWizardPracticeStackProps) => {
  return (
    <div
      className={cx(
        "relative h-full border-2 border-dusk-100 rounded-md hover:cursor-pointer px-5 pt-3 pb-[22px]",
        {
          "before:content-[''] before:absolute before:-inset-[2px] before:border-4 before:border-leaf before:rounded-md before:pointer-events-none":
            selected,
        }
      )}
      onClick={onClick}
      data-testid="govt-wizard-practice-stack"
    >
      <div className="w-12 h-12 flex items-center justify-center">
        <FontAwesomeIcon icon={icon} style={{ fontSize: 32 }} color="#2D8052" />
      </div>

      <h3 className="text-base font-body font-bold leading-[140%] tracking-[0.32px] mt-[6px]">
        {header}
      </h3>

      <p className="text-base font-body leading-[140%] tracking-[0.32px]">
        {text}
      </p>

      <p className="link text-center mt-10">
        {selected ? "Unselect" : "Select"} this practice stack
      </p>
    </div>
  )
}

export default GovtWizardPracticeStack
